export class AccountViewModel{
  userId: string;
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  addDate: Date
}

export class AddAccountViewModel{
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  newPassword?: string;
  confirmPassword?: string;
}

export class ResetPasswordViewModel{
  zoesenUserId: string;
  userName: string;
  firstName: string;
  lastName: string;
  newPassword?: string;
  confirmPassword?: string;
}

export class UpdateAccountViewModel{
  clientUserId: number;
  zoesenUserId: string;
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  avatar: string;
}


export class UpdatePasswordViewModel{
  clientUserId: number;
  zoesenUserId: string;
  userName: string;
  currentPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}